<!--
 * @Author: DY
 * @Date: 2021-05-31 11:05:57
 * @LastEditTime: 2022-10-20 17:19:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\contractProgress\invoiceList.vue
-->
<template>
    <v-touch @swiperight="onClickLeft" class="wrapper">
        <div class="invoiceList">
            <van-nav-bar
                title="发货单列表"
                left-text="供应方量"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <div class="total">
                    <div>
                        <h4>发货方量(m³)</h4>
                        <p>{{ totalData.volumeTotal }}</p>
                    </div>
                    <div>
                        <h4>签收方量(m³)</h4>
                        <p>{{ totalData.signVolumeTotal }}</p>
                    </div>
                </div>
                <div class="warpper">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                    >
                        <template v-for="(item, index) in invoiceList">
                            <div :key="`fhd_${index}`" class="materialPlan-item">
                                <h4>
                                    <span class="iconfont iconhetong">发货单编号:{{ item.pcb_number }}</span>
                                </h4>
                                <ul>
                                    <li>
                                        <van-row>
                                            <van-col span="12">
                                                <span class="pre-icon materialPlan01"></span>
                                                <span class="info">车小号：{{ item.shch }}</span>
                                            </van-col>
                                            <van-col span="12">
                                                <span class="pre-icon materialPlan02"></span>
                                                <span class="info">累计车次：{{ item.ljcs_fh }}次</span>
                                            </van-col>
                                        </van-row>
                                    </li>
                                    <li>
                                        <van-row>
                                            <van-col span="12">
                                                <span class="pre-icon materialPlan03"></span>
                                                <span class="info">本车方量：{{ item.volume }}m³</span>
                                            </van-col>
                                            <van-col span="12">
                                                <span class="pre-icon materialPlan03"></span>
                                                <span class="info">累计方量：{{ item.ljfs_fh }}m³</span>
                                            </van-col>
                                        </van-row>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </van-list>
                </div>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: 'invoice-list',
    components: {},
    props: {},
    data() {
        return {
            totalData: {
                signVolumeTotal: 0,
                volumeTotal: 0,
            },
            // 订单编号
            order_number: '',
            // 下拉刷新
            isLoading: false,
            loading: false,
            finished: false,
            invoiceList: [],
            pageindex: 1,
            // 列表总条数
            total: 0,
        };
    },
    computed: {},
    watch: {},
    created() {
        this.order_number = this.$route.params.order_number;
        // 获取发货合计数据
        this.getTotalData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页/右划回退
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 下拉刷新
        onRefresh() {
            this.pageindex = 0;
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        // 分页拉取
        onLoad() {
            if (this.isLoading) {
                this.invoiceList = [];
                this.isLoading = false;
            }
            this.pageindex += 1;
            this.invoiceListData();
        },
        // 获取发货合计数据
        getTotalData() {
            this.$axios
                .get(`/interfaceApi/production/productorder/get_supply_contract/pcb_statistics/${this.order_number}`)
                .then(res => {
                    this.totalData = res;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 发货单列表
        invoiceListData() {
            this.$axios
                .get(`/interfaceApi/production/productorder/get_supply_contract/pcb_list/${this.order_number}?pageindex=1&pagesize=4`)
                .then(res => {
                    this.total = res.total;
                    this.loading = false;
                    this.isLoading = false;
                    this.invoiceList = this.invoiceList.concat(res.rows);
                    if (this.invoiceList.length >= this.total) {
                        this.finished = true;
                    }
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
};
</script>
<style lang="stylus" scoped>
.invoiceList
    height 100%
    background #F0F0F0
    section
        height calc(100% - 44rpx)
        padding 15rpx
        .total
            padding-bottom 15rpx
            display flex
            justify-content space-between
            >div
                width calc((100% - 15rpx)/2)
                height 65rpx
                display flex
                flex-direction column
                justify-content center
                color #fff
                padding-left 40rpx
                &:nth-of-type(1)
                    background linear-gradient(to right, #FA8C47 0%,#EFAB54 100%);
                &:nth-of-type(2)
                    background linear-gradient(to right, #48A0D8 0%,#7FD0FE 100%);
                h4
                    font-size 12rpx
                    margin-bottom 3rpx
                p
                    font-size 20rpx
        .warpper
            background #F0F0F0
            position relative
            .materialPlan-item
                width 100%
                background #ffffff
                margin-bottom 15rpx
                position relative
                overflow hidden
                color #666666
                font-size 14rpx
                padding 16rpx 16rpx 5rpx 16rpx
                h4
                    margin-bottom 14rpx
                    span
                        font-size 16rpx
                        height 20rpx
                        line-height 20rpx
                        color #061F3E
                        white-space nowrap
                        &:before
                            font-size 20rpx
                            margin-right 10rpx
                            color #3495FB
                ul
                    li
                        overflow hidden
                        margin-bottom 10rpx
                        .pre-icon
                            width 16rpx
                            height 16rpx
                            float left
                            background-size 100% 100%
                            background-repeat no-repeat
                            display inline-block
                            margin 2rpx 10rpx 0 0
                            &.materialPlan01
                                background-image url(./../../../assets/images/icons/icon_18.png)
                            &.materialPlan02
                                background-image url(./../../../assets/images/icons/icon_19.png)
                            &.materialPlan03
                                background-image url(./../../../assets/images/icons/icon_30.png)
                        .info
                            float left
                            width calc(100% - 26rpx)
                        &.tit
                            font-size 16rpx
                            .icondanjubianhao
                                color #3495FB
                                font-size 18rpx
                                margin 3rpx 8rpx 0 0
                                float left
                .btn-con
                    display flex
                    position relative
                    &:after
                        content ''
                        height 15rpx
                        width 1px
                        background #D7D7D7
                        position absolute
                        left 50%
                        top 15rpx
                    .btn-item
                        flex 1
                        text-align center
                        margin 8rpx 0
                        .btn-span
                            border 1px solid #5588F1
                            display inline-block
                            text-align center
                            color #5588F1
                            border-radius 3rpx
                            padding 4rpx 8rpx
                    .btn-item01
                        position relative
                        &:before
                            content ' '
                            position absolute
                            right 0
                            width 1px
                            height 15rpx
                            background #D7D7D7
                            top 8rpx
</style>
